import React from 'react';
import PropTypes from 'prop-types';
import { Card as MuiCard, CardHeader, CardContent, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function QuickActionsCard({ actions }) {
  return (
    <MuiCard elevation={3} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader title="Acciones Rápidas" sx={{ pb: 0 }} />
      <CardContent sx={{ flexGrow: 1 }}>
        <Stack spacing={1}>
          {actions.map(({ label, icon, to }, idx) => (
            <Button
              key={idx}
              component={RouterLink}
              to={to}
              variant="outlined"
              size="small"
              startIcon={icon && <i className={icon} />}
              sx={{ justifyContent: 'flex-start', py: 1 }}
            >
              <Typography variant="body2" fontWeight={500} textTransform="none">
                {label}
              </Typography>
            </Button>
          ))}
        </Stack>
      </CardContent>
    </MuiCard>
  );
}

QuickActionsCard.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
      to: PropTypes.string.isRequired,
    })
  ),
};

QuickActionsCard.defaultProps = {
  actions: [
    { label: 'Ver estadísticas avanzadas', icon: 'bi bi-graph-up', to: '/stats' },
    { label: 'Configurar alertas', icon: 'bi bi-bell', to: '/alerts' },
    { label: 'Configurar cuenta', icon: 'bi bi-gear', to: '/settings' },
  ],
};
